import "../../../styles/login.css";

import * as loginService from "../../services/login";
import * as settings from "../../services/settings";

import { Button, Form, Input, Layout, Spin, notification } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone, LockOutlined, UserOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";

import { resolveLandingPathFromToken } from "../../utils/landingPath";
import { useAccessToken } from "../../contexts/AccessTokenContext";
import { useNavigate } from "react-router-dom";

const { Content } = Layout;

const Login = () => {
  const [formLogin] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { setAccessToken } = useAccessToken();

  const navigation = useNavigate();

  // login ค้างไว้อยู่แล้ว → ไม่ต้องแสดงหน้า login ซ้ำ เข้าหน้าแรกที่ user คนนั้นมีสิทธิ์เลย
  // (ไม่ fix เป็น /home เพราะ dashboard ผูก Dashboard.VIEW แล้ว — คนไม่มีสิทธิ์จะเด้งไปมา)
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigation(resolveLandingPathFromToken(token), { replace: true });
    }
  }, [navigation]);

  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const onSubmit = async () => {
    const values = await formLogin.getFieldsValue();
    const { username, password } = values || {};
    const body = {
      username,
      password,
    };
    setLoading(true);
    try {
      const { access_token } = await loginService.login(body);
      // localStorage.setItem('token', access_token)
      setAccessToken(access_token);
      // อ่านสิทธิ์จาก token ที่เพิ่งได้ (ไม่รอ state) → พาไปหน้าแรกที่ user คนนี้เข้าได้
      navigation(resolveLandingPathFromToken(access_token));
      setLoading(false);
    } catch (err) {
      console.error("[Login] onSubmit: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message || "Login failed"}`}</>);
      setLoading(false);
    }
  };

  return (
    <>
      {contextHolder}
      <Layout className="layout">
        <Content className="content-login">
          <Spin spinning={loading}>
            <Form form={formLogin} name="normal_login" className="login-form">
              <Form.Item
                name="username"
                key="username"
                rules={[
                  {
                    required: true,
                    message: "Please input your Username!",
                  },
                ]}
              >
                <Input size="large" prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Username" />
              </Form.Item>

              <Form.Item
                name="password"
                key="password"
                rules={[
                  {
                    required: true,
                    message: "Please input your Password!",
                  },
                ]}
              >
                <Input.Password
                  size="large"
                  type="password"
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  placeholder="input password"
                  iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                />
              </Form.Item>
              <Form.Item>
                {/* <Link
                  href={{
                    pathname: '/forgot/[id]',
                    query: { id: id },
                  }}
                > */}
                {/* <a className='login-form-forgot'>
                  <span className='span-form'>Forgot password</span>
                </a> */}
                {/* </Link> */}
              </Form.Item>
              <Form.Item className="mb-0">
                <Button
                  size="large"
                  type="primary"
                  htmlType="submit"
                  onClick={onSubmit}
                  className="login-form-button mb-15"
                >
                  Log in
                </Button>
              </Form.Item>
            </Form>
          </Spin>
        </Content>
        <Footer />
      </Layout>
    </>
  );
};

const Footer = () => {
  return (
    <footer className={"absolute w-full bottom-0 pb-1"}>
      <div className="container mx-auto px-4">
        {/* <hr className="mb-6 border-b-1 border-blueGray-200" /> */}
        <div className="flex flex-wrap items-center md:justify-between justify-center">
          <div className="w-full px-4">
            <div className="text-sm font-semibold py-1 text-center text-back mt-6">
              Copyright © {new Date().getFullYear()} Logistic All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Login;
